import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable()
export class ApiService {
	constructor(private http: HttpClient) {}
	getEmbedUrlForLooker(
		dashboard: string,
		filters: Record<string, string> = {}
	) {
		return this.http.get<string>(`accounts/looker/${dashboard}`, {
			params: {
				...filters,
			},
		});
	}

	getEmbedTokenForSuperset(dashboardId: string) {
		return this.http.get<{ token: string }>(`accounts/superset/${dashboardId}`);
	}
}
